import React, { useState, useEffect, useRef } from "react";
import { Alert, Button, Col, Descriptions, Divider, Form, Input, Layout, Modal, Row, Table, Tag, Typography, Skeleton, Space, notification } from 'antd';
import { CaretLeftOutlined, CaretRightOutlined, BankOutlined, UserAddOutlined, EditOutlined, QrcodeOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from "react-router-dom";
import { cloneDeep } from "lodash";
import moment from "moment-timezone";
import { inject, observer } from "mobx-react";
import Swal from "sweetalert2";
import QRScanner from "./QRScanner";
import "./style.scss";

const { Content } = Layout;
const { Text } = Typography;

const ViewEvent = ({ userStore, eventStore, voterStore }) => {

  const { Title } = Typography;
  const navigate = useNavigate()

  const [isOpenQR, setIsOpenQR] = useState(false);
  // const [selectedDisplayedID, setSelectedDisplayedID] = useState();
  
  // FOR MODAL INPUT ID
  const [form] = Form.useForm();
  const [isOpenForm, setIsOpenForm] = useState(false);
  const [showData, setShowData] = useState(false);
  let { id } = useParams();

  const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];
  const teamLeaderID = login_user && login_user.userID;

  const [currentTime, setCurrentTime] = useState();
  const [endTime, setEndTime] = useState();
  const [startTime, setStartTime] = useState();

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowData(true);
    }, 500);

    return () => clearTimeout(timeout); // Clear the timeout if the component is unmounted

  }, []);

  useEffect(() => {
    eventStore.page = 1;
    eventStore.hasMore = false;
    eventStore.perPage = 10;
    
    eventStore.pageReceived = 1;
    eventStore.hasMoreReceived = false;
    eventStore.perPageReceived = 10;

    // voterStore.pageCash = 1;
    // voterStore.hasMoreCash = false;
    // voterStore.perPageCash = 10;

    // voterStore.pageItem = 1;
    // voterStore.hasMoreItem = false;
    // voterStore.perPageItem = 20;
    if(id){
      eventStore.fetchEventByID(id);
      // voterStore.fetchVoterAmountEventCashByID(id);
      // voterStore.fetchVoterAmountEventItemByID(id);
    }
  }, [id]);

  useEffect(() => {

    const status = 'PENDING';

    if(id){
      eventStore.fetchEventsRegistrationPending(id, teamLeaderID, status);
    }
    
  }, []);

  useEffect(() => {
    
    const status = 'RECEIVED';

    if(id){
      eventStore.fetchEventsRegistrationReceived(id, teamLeaderID, status);
    }
    
  }, []);


  useEffect(() => {
      if (eventStore.event) {


          const getCurrentTime = moment().utcOffset(8).format("HH:mm");
          const eventEndTime = moment.utc(eventStore.event.RegistrationEnd).format("HH:mm");
          const eventStartTime = moment.utc(eventStore.event.RegistrationStart).format("HH:mm");
          
          console.log("current time:"+getCurrentTime);
          console.log("end time:"+eventEndTime);
          console.log("start time:"+eventStartTime);
          console.log("date:"+eventStore.event.Date)
          console.log(moment.utc().isSameOrBefore(moment.utc(eventStore.event.Date, "YYYY-MM-DD")));
        
          setCurrentTime(getCurrentTime);
          setEndTime(eventEndTime);
          setStartTime(eventStartTime);
      }
  }, [eventStore.event]); 

  const formatNumber = (formatnumber) => {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(formatnumber);
  };

  const columnsRegistered = [
    {
      title: 'ID',
      key: 'DisplayedID+EventRegistrationID',
      dataIndex: 'DisplayedID',
      render: (DisplayedID) => (
        <Text default strong>{DisplayedID}</Text>
      )
    },
    {
      title: 'Name',
      key: 'VoterName+EventRegistrationID',
      dataIndex: 'VoterName',
      render: (VoterName) => (
        <Text default>{VoterName}</Text>
      )
    },

    {
      title: 'Status',
      dataIndex: 'Status',
      responsive: ['lg', 'xl', 'md'],
      render: (Status) => (
        <Text default strong><Tag color={Status === 'RECEIVED' ? 'green' : 'blue'}>{Status}</Tag></Text>
      )
    },

    // {
    //   title: 'Action',
    //   dataIndex: 'action',
    //   key: 'action',
    //   render: (text, record) => (
    //     <Space size={'small'}>
    //       <Button icon={<QrcodeOutlined />} 
    //         disabled={
    //           currentTime >= startTime && 
    //           currentTime <= endTime &&
    //           moment.utc().isSameOrBefore(moment.utc(eventStore.event.Date, "YYYY-MM-DD"))
              
    //         } 
    //         type="primary" onClick={() => {
    //         setSelectedDisplayedID(record.DisplayedID);
    //         setIsOpenQR(true)
    //       }}>Redeem</Button>
    //     </Space>
    //   )
    // },
  ];

  const columnsReceived = [
    {
      title: 'ID',
      key: 'DisplayedID+EventRegistrationID',
      dataIndex: 'DisplayedID',
      render: (DisplayedID) => (
        <Text default strong>{DisplayedID}</Text>
      )
    },
    {
      title: 'Name',
      key: 'VoterName+EventRegistrationID',
      dataIndex: 'VoterName',
      render: (VoterName) => (
        <Text default>{VoterName}</Text>
      )
    },

    {
      title: 'Status',
      key: 'Status+EventRegistrationID',
      dataIndex: 'Status',
      render: (Status) => (
        <Text default strong><Tag color={Status === 'RECEIVED' ? 'green' : 'blue'}>{Status}</Tag></Text>
      )
    },
  ];

  const handlePrevPageRegistered = () => {
    eventStore.page = eventStore.page - 1;

    const status = 'PENDING';

    if(id){
      eventStore.fetchEventsRegistrationPending(id, teamLeaderID, status);
    }
  };

  const handleNextPageRegistered = () => {
    eventStore.page = eventStore.page + 1;

    const status = 'PENDING';

    if(id){
      eventStore.fetchEventsRegistrationPending(id, teamLeaderID, status);
    }
  };

  const handlePrevPageReceived = () => {
    eventStore.pageReceived = eventStore.pageReceived - 1;

    const status = 'RECEIVED';

    if(id){
      eventStore.fetchEventsRegistrationReceived(id, teamLeaderID, status);
    }
  };

  const handleNextPageReceived = () => {
    eventStore.pageReceived = eventStore.pageReceived + 1;

    const status = 'RECEIVED';

    if(id){
      eventStore.fetchEventsRegistrationReceived(id, teamLeaderID, status);
    }
  };

  const onFinish = (values) => {

    const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];
    const teamLeaderID = login_user && login_user.userID;

    if(id){
      eventStore.scanQRRegisteredUser(values.displayedID, id, teamLeaderID)
    }
    
  };

  const handleScan = (values) => {

    setIsOpenForm(false);

    const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];
    const teamLeaderID = login_user && login_user.userID;

    if(id){
      eventStore.scanQRRegisteredUser(values.displayedID, id, teamLeaderID)
    }

  };

  return (
    <div className="view-voter">
      <Content>
        <div className="view-voter-content">
          <Title level={4}>Event Details</Title>
          <Divider />
          {
            showData ? (
            <>
              <div className="information">
                <Row justify={"space-between"} align={"middle"}>
                  <Col>
                    <Title level={5}>Voters Amount List</Title>
                  </Col>
                  <Col>
                    <Space>
                      <Button type="primary" onClick={() => navigate('eventregistration')}><UserAddOutlined/>Voters Event Registration</Button>
                    </Space>
                  </Col>
                </Row>
                <Divider/>
                <Descriptions column={{xs: 1 , sm: 1, md: 1, lg: 2, xl: 2, xxl: 2}} bordered>
                  <Descriptions.Item label="Event Name" span={1}>
                    <Text type="primary">{ eventStore.event && eventStore.event.EventName }</Text>
                  </Descriptions.Item>
                  <Descriptions.Item label="Event Date" span={1}>
                    <Text type="primary">{ moment(eventStore.event && eventStore.event.Date).format("MMM DD, YYYY") }</Text>
                  </Descriptions.Item>
                  <Descriptions.Item label="Location" span={1}>
                    <Text type="primary">{ eventStore.event && eventStore.event.Location }</Text>
                  </Descriptions.Item>
                </Descriptions>
                <Divider/>
                <Descriptions column={{xs: 1 , sm: 1, md: 1, lg: 2, xl: 2, xxl: 2}} bordered>
                  <Descriptions.Item label="Total Spent Budget" span={1}>
                    <Text type="primary" strong>₱ { formatNumber( eventStore.event && eventStore.event.TotalAmount ) }</Text>
                  </Descriptions.Item>
                </Descriptions>
                <Divider/>
                <>
                  <Row gutter={10} style={{ marginBottom: 16 }}>
                      <Col>
                          <Text strong>Registration Start Time:</Text>
                          <Text style={{ marginLeft: 8 }}>{startTime ? moment.utc(eventStore.event && eventStore.event.RegistrationStart).format('hh:mm A') : 'N/A'}</Text>
                      </Col>
                      <Col>
                          <Text strong>Registration End Time:</Text>
                          <Text style={{ marginLeft: 8 }}>{endTime ? moment.utc(eventStore.event && eventStore.event.RegistrationEnd).format('hh:mm A') : 'N/A'}</Text>
                      </Col>
                  </Row>

                  <Row justify={"space-between"} align={"middle"}>
                  <Col>
                    <Title level={5}>Registered Users</Title>
                  </Col>
                  <Col>
                    <Space>
                      <Button type="primary" onClick={() => setIsOpenQR(true)}><QrcodeOutlined/>Redeem </Button>
                    </Space>
                  </Col>
                </Row>
                  
                  <Table scroll={{x: "max-content"}} pagination={false} columns={columnsRegistered} dataSource={cloneDeep(eventStore.eventRegistrations)} bordered 
                  expandable={{
                    expandedRowRender: (record) => (
                     <>
                      <Title level={5}>Item Details</Title>
                      <Row gutter={20}>
                        <Col>
                          <Text type="primary">Item : </Text><Text type="primary" strong>{record.ItemName ? record.ItemName : "N/A"}</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Quantity : </Text><Text type="primary" strong>{record.ItemQuantity}</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Price Per Unit : </Text><Text type="primary" strong>₱{formatNumber(record.ItemPricePerUnit)}</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Item Amount : </Text><Text type="primary" strong>₱{formatNumber(record.ItemTotalAmount)}</Text>
                        </Col>
                      </Row>
                      <Title level={5}>Cash Details</Title>
                      <Row gutter={20}>
                        <Col>
                          <Text type="primary">Item : </Text><Text type="primary" strong>Cash</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Cash Amount : </Text><Text type="primary" strong>₱{formatNumber(record.Cash)}</Text>
                        </Col>
                      </Row>
                     </>
                    ),
                    // rowExpandable: (record) => record.name !== 'Not Expandable',
                  }}
                  />
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageRegistered} disabled={eventStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{eventStore.page}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPageRegistered} disabled={eventStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                </>
                <Divider/>
                <>
                  <Row justify={"space-between"} align={"middle"}>
                    <Col>
                      <Title level={5}>Users Received Cash/Item </Title>
                    </Col>
                  </Row>
                  
                  <Table scroll={{x: "max-content"}} pagination={false} columns={columnsReceived} dataSource={cloneDeep(eventStore.eventReceivedRegistrations)} bordered 
                  expandable={{
                    expandedRowRender: (record) => (
                     <>
                      <Title level={5}>Item Details</Title>
                      <Row gutter={20}>
                        <Col>
                          <Text type="primary">Item : </Text><Text type="primary" strong>{record.ItemName ? record.ItemName : "N/A"}</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Quantity : </Text><Text type="primary" strong>{record.ItemQuantity}</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Price Per Unit : </Text><Text type="primary" strong>₱{formatNumber(record.ItemPricePerUnit)}</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Item Amount : </Text><Text type="primary" strong>₱{formatNumber(record.ItemTotalAmount)}</Text>
                        </Col>
                      </Row>
                      <Title level={5}>Cash Details</Title>
                      <Row gutter={20}>
                        <Col>
                          <Text type="primary">Item : </Text><Text type="primary" strong>Cash</Text>
                        </Col>
                        <Col>
                          <Text type="primary">Cash Amount : </Text><Text type="primary" strong>₱{formatNumber(record.Cash)}</Text>
                        </Col>
                      </Row>
                     </>
                    ),
                    // rowExpandable: (record) => record.name !== 'Not Expandable',
                  }}
                  />
                  <ul className="pagination">
                    <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPageReceived} disabled={eventStore.pageReceived == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                    <li className="pagination-item"><a>{eventStore.pageReceived}</a></li>
                    <li className="pagination-next "><Button type="dashed" onClick={handleNextPageReceived} disabled={eventStore.hasMoreReceived ? false : true}>Next<CaretRightOutlined /></Button></li>
                  </ul>
                </>
              </div>
            </>
            ) : <Skeleton active/>
          }
          <Divider/>
          <Row justify={'end'} gutter={10}>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>
        </div>
      </Content>
      {/* MODAL FOR INPUT ID */}
      <Modal 
        title="Input Registered User ID" 
        open={isOpenForm} 
        okText={"Submit"}
        onOk={() => {
          form
            .validateFields() // Validate fields first
            .then(() => {
              form.submit();
              setIsOpenForm(false); // Only close if validation passes
            })
            .catch(() => {
              // Prevent closing when validation fails
            });
        }}
        onCancel={() => setIsOpenForm(false)}
      >
        <Form 
          name="addbillingInformationForm"
          layout="vertical"
          form={form} 
          onFinish={onFinish}
        >
          <Form.Item
            label="ID"
            name="displayedID"
            rules={[
              {
                required: true,
                message: 'Please input Registered User ID.',
              },
            ]}
          >
            <Input placeholder="Enter ID" style={{ width: "100%" }}/>
        </Form.Item>
        <Divider/>
        </Form>
      </Modal>
      {/* Redeem Options Modal */}
      <Modal
        title="Redeem Cash/Item"
        open={isOpenQR}
        onCancel={() => setIsOpenQR(false)}
        footer={[
          <Button key="inputID" type="default" onClick={() => {
            setIsOpenQR(false);
            setIsOpenForm(true);
            form.resetFields();
          }}>
            Input ID
          </Button>,
          <QRScanner onScan={handleScan}/>
        ]}
      >
        <Text>How would you like to redeem?</Text>
      </Modal>
    </div>

  );
};

export default inject('userStore', 'eventStore', 'voterStore')(observer(ViewEvent));

